import { FC } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface MenuItem {
  icon: string;
  label: string;
  path: string;
}

export const FooterMenu: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems: MenuItem[] = [
    {
      icon: '/images/icon/icons8-add-new-500.png',
      label: '画像生成',
      path: '/image-generation'
    },
    {
      icon: '/images/icon/icons8-gallery-512.png',
      label: 'インスピ',
      path: '/inspiration'
    },
    {
      icon: '/images/icon/icons8-gallery-480.png',
      label: '生成履歴',
      path: '/generation-history'
    },
    {
      icon: '/images/icon/icons8-male-user-512.png',
      label: 'アカウント',
      path: '/account'
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 sm:hidden">
      <div className="flex items-center h-16">
        {menuItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex-1 flex flex-col items-center justify-center py-2 ${
              location.pathname === item.path ? 'text-blue-600' : 'text-gray-600'
            }`}
          >
            <img 
              src={item.icon} 
              alt={item.label} 
              className={`w-6 h-6 mb-1 ${
                location.pathname === item.path ? 'opacity-100' : 'opacity-60'
              }`}
              style={{
                filter: location.pathname === item.path 
                  ? 'invert(47%) sepia(89%) saturate(3039%) hue-rotate(209deg) brightness(97%) contrast(96%)' 
                  : 'none'
              }}
            />
            <span className='text-xs'>{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};